/**
 * Loads and caches the Sword Drill UI content.
 * The Sword Drill page awaits this on first load; all child components
 * call it without await and receive the already-cached result instantly.
 */
export function useSwordDrillUI() {
  return useAsyncData('sword-drill-ui', () =>
    queryCollection('swordDrillUI').first(),
  )
}
